// The session token lives in an httpOnly cookie set by the backend; only the non-secret profile is kept here.
localStorage.removeItem('token');

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user'));
  } catch {
    return null;
  }
};

export const setAuth = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearAuth = async () => {
  localStorage.removeItem('user');
  try {
    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' });
  } catch {
    // network failure: the cookie expires on its own
  }
};

export const isAuthenticated = () => !!getUser();

export const getUserRole = () => getUser()?.role;
